/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import"components/MenuBar";import"components-icon/index";